import { InternalAxiosRequestConfig } from 'axios';
import { useOrganizationStore } from '@/store/modules/useOrganizationStore';
import { Authentication } from '@/modules/authentication/Authentication';

export const axiosRequestInterceptorClientHeader = (config: InternalAxiosRequestConfig) => {
  const organizationStore = useOrganizationStore();

  if (organizationStore.currentWarehouse && !config.headers['sub-organization']) {
    config.headers['sub-organization'] = organizationStore.currentWarehouse.id;
  }
};

export const axiosRequestInterceptorAuthorizationHeader = (config: InternalAxiosRequestConfig) => {
  const accessToken = Authentication.accessToken;

  if (accessToken && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }
};
